import { AlertCircle, CheckCircle2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface AuthAlertProps {
  message: string
  variant?: 'error' | 'success'
  className?: string
}

export function AuthAlert({ message, variant = 'error', className }: AuthAlertProps) {
  const isError = variant === 'error'
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-lg border px-3 py-2.5 text-sm',
        isError
          ? 'border-destructive/20 bg-destructive/10 text-destructive'
          : 'border-emerald-500/20 bg-emerald-500/10 text-emerald-500',
        className
      )}
    >
      {isError ? (
        <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
      ) : (
        <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" />
      )}
      <span className="leading-5">{message}</span>
    </div>
  )
}
